import React, { useEffect, useState } from 'react';
import SelectCurrency from './SelectCurrency'
import Grid from "@material-ui/core/Grid";
import axios from 'axios';
import {connect} from 'react-redux'

function CurrencySelector(props) {
    const [currencyValue, setCurrencyValue] = useState(localStorage.getItem('selectedCurrency') ? localStorage.getItem('selectedCurrency') : null)
    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        if (!localStorage.getItem('selectedCurrency')) 
        {
            let response = await axios.get(`https://api.ipdata.co/?api-key=2149942249e807260b34e1d274c9f199d9d49276a3589ae9de828b35`)
            if (response && response.data) {
                let data = response.data.currency.code
                const {dispatch}=props;
                dispatch({type:'SET_CURRENCY',currency:data})
                setCurrencyValue(data);
            }
        }
    }

    useEffect(() => {
        localStorage.setItem('selectedCurrency', currencyValue)
        const {dispatch}=props;
        dispatch({type:'SET_CURRENCY',currency:currencyValue})
        if (props.currencyChangeHandler) {
            props.currencyChangeHandler(currencyValue)
        }
    }, [currencyValue])

    return (
        <Grid container >
            
            <Grid item xs="12">
                <div className='currency-box'>
                <SelectCurrency value={currencyValue} readOnly={props.readOnly?true:false} handleChange={setCurrencyValue} />
           </div>
            </Grid>
        </Grid>
    )
}

const mapStateWithProps = (state) => ({
    currency:state.flight.currency
  });
  
  
  
  export default React.memo(connect(mapStateWithProps)(CurrencySelector));